import { createContext, useContext, useState } from "react";

const KitchenContext = createContext();

export function KitchenProvider({ children }) {
  const [kitchenCount, setKitchenCount] = useState(0);
  const [kitchenSocket, setKitchenSocket] = useState(0);

  return <KitchenContext.Provider value={{ kitchenCount, setKitchenCount, kitchenSocket, setKitchenSocket }}>{children}</KitchenContext.Provider>;
}

export function useKitchen() {
  return useContext(KitchenContext);
}
